/* eslint-disable react/prop-types */
import React from 'react'
import DefaultContext  from "flexbiz-core/components/auth/Context";
import CartContext  from "./CartContext";
import {EmitEvents} from 'flexbiz-core/utils';
//import _ from "lodash";
class Provider extends React.Component{
  constructor(props){
    super(props);
    let cart,order;
    if(localStorage.getItem("cart")){
      try{
        cart = JSON.parse(localStorage.getItem("cart"));
        if(!cart) cart =[];
        if(!cart.length) cart =[];
      }catch(e){
        cart =[];
      }
    }else{
      cart =[];
    }
    if(localStorage.getItem("order")){
      try{
        order = JSON.parse(localStorage.getItem("order"));
      }catch(e){
        console.error(e);
      }
    }
    this.state={
      cart,order,
      load:0,
      addToCart:this.addToCart.bind(this),
      updateCart:this.updateCart.bind(this),
      deleteCart:this.deleteCart.bind(this),
      clearCart:this.clearCart.bind(this),
      createOrder:this.createOrder.bind(this),
    }
    this.handleLogout = ()=>{
      this.setState({cart:[],order:[]});
    }
    this.handleLogout = this.handleLogout.bind(this);

    EmitEvents.subscribe(`logout`,this.handleLogout)

  }
  shouldComponentUpdate(nextProps,nextState){
    return nextState.load!==this.state.load;
  }
  componentWillUnmount(){
    EmitEvents.unsubscribe(`logout`,this.handleLogout)
  }
  async componentDidMount(){
   
  }
  async addToCart(data){
    const {cart} = this.state;

    let _c = cart.find(c=>c.ma_vt === data.ma_vt && c.ma_dvt==data.ma_dvt && (c.ma_tt1||"")==(data.ma_tt1||""));

    data.he_so_qd = data.he_so_qd||1;
    data.sl_xuat_qd = data.sl_xuat * data.he_so_qd;

    let t_sl = cart.filter(d=>d.ma_nvt===data.ma_nvt).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0) + data.sl_xuat_qd;

    let t_sl_ntt = cart.filter(d=>d.nh_tt===data.nh_tt).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0) + data.sl_xuat_qd;

    let t_tien_ntt = cart.filter(d=>d.nh_tt===data.nh_tt).map(d=>d.tien_hang_ct_nt||0).reduce((a,b)=>a+b,0) + (data.sl_xuat *(data.gia_ban_le_ct||data.gia_ban_ct||0));
    let so_luong = data.sl_xuat_qd;

    let vt = await this.context.apis.asyncGetData(this.context.userInfo.token,"dmvt",{ma_tt1:data.ma_tt1,ma_tt2:data.ma_tt2,ma_tt3:data.ma_tt3,ma_vt:data.ma_vt,ma_dvt_sd:data.ma_dvt,gia_theo_kh:true,so_luong,t_sl,t_sl_ntt,t_tien_ntt,get_properties:false});
    if(!vt) return this.context.alert(this.context.apis.getLabel("Sản phẩm này không tồn tại"));
    data.gia_ban_nt = vt.gia_ban_le;

    data.ma_nvt = vt.ma_nvt;

    let thue_suat = data.thue_suat||0;
    data.gia_ban_ct_nt = data.gia_ban_nt/(1+thue_suat/100);

    if(_c){
      _c.sl_xuat = _c.sl_xuat + data.sl_xuat;
      _c.tien_hang_nt =  _c.sl_xuat * data.gia_ban_nt;
      _c.tien_hang_ct_nt =  _c.sl_xuat * data.gia_ban_ct_nt;
      _c.gia_ban_le_sau_ck = vt.gia_ban_le_sau_ck;
      _c.gia_ban_ck = vt.gia_ban_ck;

    }else{
      data.tien_ck = data.tien_ck_nt = data.tien_ck||0;
      _c = {...data};
      _c.gia_ban_nt = _c.gia_ban_le||0;
      _c.tien_hang_nt = (_c.sl_xuat||0) * _c.gia_ban_nt;
      _c.gia_ban_le_sau_ck = vt.gia_ban_le_sau_ck;
      _c.gia_ban_ck = vt.gia_ban_ck;
      
      _c.gia_ban_ct_nt = _c.gia_ban_nt/(1+thue_suat/100);
      _c.tien_hang_ct_nt = (_c.sl_xuat||0) * _c.gia_ban_ct_nt;
      _c.order_time = new Date();
      _c.sl_ht = 0;
      _c.sl_gui_bep =0;
      _c.sl_gui_bartender =0;
      _c.sl_order = 0;
      _c.line = new Date().getTime();
      delete _c.signature;
      cart.push(_c);
    }
    //tinh chiet khau
    _c.tien_ck_nt  = (data.ty_le_ck? _c.tien_hang_ct_nt*data.ty_le_ck/100:data.tien_ck_nt*data.sl_xuat)
    //thue
    _c.tien_thue_nt = (_c.tien_hang_ct_nt - _c.tien_ck_nt) * thue_suat/100;
    _c.tien_nt  = _c.tien_hang_ct_nt - _c.tien_ck_nt + _c.tien_thue_nt;
    //update gia cho cac san pham cung nhom
    await Promise.all(cart.filter(c=>c.ma_nvt===data.ma_nvt && c.ma_vt !== data.ma_vt).map(_c=>{
      return (async ()=>{
        //console.log("update cart for",_c.ma_vt);
        let t_sl = cart.filter(d=>d.ma_nvt===_c.ma_nvt).map(d=>d.sl_xuat||0).reduce((a,b)=>a+b,0);
        let t_sl_ntt = cart.filter(d=>d.nh_tt===_c.nh_tt).map(d=>d.sl_xuat||0).reduce((a,b)=>a+b,0);

        let vt = await this.context.apis.asyncGetData(this.context.userInfo.token,"dmvt",{ma_tt1:_c.ma_tt1,ma_tt2:_c.ma_tt2,ma_tt3:_c.ma_tt3,ma_vt:_c.ma_vt,ma_dvt_sd:_c.ma_dvt,gia_theo_kh:true,so_luong:_c.sl_xuat,t_sl,t_sl_ntt});
        if(!vt) return this.deleteCart(_c);
    
        _c.gia_ban_nt = vt.gia_ban_le;
        _c.gia_ban_le_sau_ck = vt.gia_ban_le_sau_ck;
        _c.gia_ban_ck = vt.gia_ban_ck;

        _c.ma_nvt = vt.ma_nvt;
    
        let thue_suat = _c.thue_suat||0;
        _c.gia_ban_ct_nt = _c.gia_ban_nt/(1+thue_suat/100);
       
    
        _c.tien_hang_nt =  _c.sl_xuat * _c.gia_ban_nt;
        _c.tien_hang_ct_nt =  _c.sl_xuat * _c.gia_ban_ct_nt;

        //tinh chiet khau
        _c.tien_ck_nt  = (_c.ty_le_ck?_c.tien_hang_ct_nt*_c.ty_le_ck/100:0);
        //tien thue
        _c.tien_thue_nt = (_c.tien_hang_ct_nt - _c.tien_ck_nt) * thue_suat/100;
    
        _c.tien_nt  = _c.tien_hang_ct_nt - _c.tien_ck_nt + _c.tien_thue_nt;

      })();
    }))
    //
    try{
      this.setState({cart,load:this.state.load+1});
      localStorage.setItem("cart",JSON.stringify(cart));
    }catch(e){
      console.error(e);
      this.context.alert(e.message || e.error || e)
    }
  }
  async updateCart(data){
    let {cart} = this.state;
    //if(data.sl_xuat===0) return this.deleteCart(data);
    if(data.sl_xuat===0) cart = cart.filter(c=>!(c.ma_vt==data.ma_vt &&  (c.ma_tt1||"")==(data.ma_tt1||"")));
    let _c = cart.find(c=>c.ma_vt==data.ma_vt && c.ma_dvt==data.ma_dvt && (c.ma_tt1||"")==(data.ma_tt1||""));
    if(_c){
      _c.sl_xuat = data.sl_xuat;
      _c.he_so_qd = data.he_so_qd ||1;
      _c.sl_xuat_qd = data.sl_xuat * _c.he_so_qd;
      _c.ty_le_ck = data.ty_le_ck;
      _c.ghi_chu = data.ghi_chu;
    }
    //update gia
    await Promise.all(cart.filter(c=>c.ma_nvt===data.ma_nvt || c.ma_vt === data.ma_vt).map(_c=>{
      return (async ()=>{
        
        let t_sl = cart.filter(d=>d.ma_nvt===_c.ma_nvt).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0);
        let t_sl_ntt = cart.filter(d=>d.nh_tt===_c.nh_tt).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0);
        let t_tien_ntt = cart.filter(d=>d.nh_tt===data.nh_tt).map(d=>d.tien_hang_ct_nt||0).reduce((a,b)=>a+b,0);

        let vt = await this.context.apis.asyncGetData(this.context.userInfo.token,"dmvt",{ma_tt1:_c.ma_tt1,ma_tt2:_c.ma_tt2,ma_tt3:_c.ma_tt3,ma_vt:_c.ma_vt,ma_dvt_sd:_c.ma_dvt,gia_theo_kh:true,so_luong:_c.sl_xuat_qd,t_sl,t_sl_ntt,t_tien_ntt});
        if(!vt) return;// this.deleteCart(_c);

        //console.log("update cart for",_c,t_sl);
    
        _c.gia_ban_nt = vt.gia_ban_le;
        _c.gia_ban_le_sau_ck = vt.gia_ban_le_sau_ck;
        _c.gia_ban_ck = vt.gia_ban_ck;
        
        _c.ma_nvt = vt.ma_nvt;
    
        let thue_suat = _c.thue_suat||0;
        _c.gia_ban_ct_nt = _c.gia_ban_nt/(1+thue_suat/100);
       
    
        _c.tien_hang_nt =  _c.sl_xuat * _c.gia_ban_nt;
        _c.tien_hang_ct_nt =  _c.sl_xuat * _c.gia_ban_ct_nt;

        //tinh chiet khau
        _c.tien_ck_nt  = (_c.ty_le_ck?_c.tien_hang_ct_nt*_c.ty_le_ck/100:0);
        //tien thue
        _c.tien_thue_nt = (_c.tien_hang_ct_nt - _c.tien_ck_nt) * thue_suat/100;
    
        _c.tien_nt  = _c.tien_hang_ct_nt - _c.tien_ck_nt + _c.tien_thue_nt;

      })();
    }))
    try{
      this.setState({cart,load:this.state.load+1});
      localStorage.setItem("cart",JSON.stringify(cart));
    }catch(e){
      console.error(e);
      this.context.alert(e.message || e.error || e)
    }
  }
  
  async deleteCart(data){
    let {cart} = this.state;
    cart = cart.filter(c=>!(c.ma_vt == data.ma_vt && c.ma_dvt===data.ma_dvt  && (c.ma_tt1||"")==(data.ma_tt1||"")));
    //update gia cho cac san pham cung nhom
    await Promise.all(cart.filter(c=>c.ma_nvt===data.ma_nvt).map(_c=>{
      return (async ()=>{
        //console.log("update cart for",_c.ma_vt);
        let t_sl = cart.filter(d=>d.ma_nvt===_c.ma_nvt).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0);
        let t_sl_ntt = cart.filter(d=>d.nh_tt===_c.nh_tt).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0);
        let t_tien_ntt = cart.filter(d=>d.nh_tt===data.nh_tt).map(d=>d.tien_hang_ct_nt||0).reduce((a,b)=>a+b,0);

        let vt = await this.context.apis.asyncGetData(this.context.userInfo.token,"dmvt",{ma_tt1:_c.ma_tt1,ma_tt2:_c.ma_tt2,ma_tt3:_c.ma_tt3,ma_vt:_c.ma_vt,ma_dvt_sd:_c.ma_dvt,gia_theo_kh:true,so_luong:_c.sl_xuat_qd,t_sl,t_sl_ntt,t_tien_ntt});
        if(!vt) return; //this.deleteCart(_c);
    
        _c.gia_ban_nt = vt.gia_ban_le;
        _c.gia_ban_le_sau_ck = vt.gia_ban_le_sau_ck;
        _c.gia_ban_ck = vt.gia_ban_ck;

        _c.ma_nvt = vt.ma_nvt;
    
        let thue_suat = _c.thue_suat||0;
        _c.gia_ban_ct_nt = _c.gia_ban_nt/(1+thue_suat/100);
       
    
        _c.tien_hang_nt =  _c.sl_xuat * _c.gia_ban_nt;
        _c.tien_hang_ct_nt =  _c.sl_xuat * _c.gia_ban_ct_nt;

        //tinh chiet khau
        _c.tien_ck_nt  = (_c.ty_le_ck?_c.tien_hang_ct_nt*_c.ty_le_ck/100:0);
        //tien thue
        _c.tien_thue_nt = (_c.tien_hang_ct_nt - _c.tien_ck_nt) * thue_suat/100;
    
        _c.tien_nt  = _c.tien_hang_ct_nt - _c.tien_ck_nt + _c.tien_thue_nt;

      })();
    }))
    //
    try{
      this.setState({cart,load:this.state.load+1});
      localStorage.setItem("cart",JSON.stringify(cart));
    }catch(e){
      console.error(e);
      this.context.alert(e.message || e.error || e)
    }
  }
  clearCart(){
    let cart =[]
    localStorage.setItem("cart",JSON.stringify(cart));
    this.setState({cart,load:this.state.load+1});
  }

  
  async createOrder(){
    let voucher_code="dh2_agent",so_ct="DH2";
    if(this.context.appInfo.app_code=="MIDOMAX"){
      voucher_code="dh2_agent_midomax"
    }
    const data={};

    let stock_info ={};
    if((this.context.queryParams||{}).for_agent==1){
      stock_info = (this.context.appInfo.par||{}).stock_info;
      if(!stock_info && this.context.appInfo.par.group.is_employee_group){
        stock_info = await new Promise((rs)=>{
          this.context.objectPicker('dmkho_agent',this.context.apis.getLabel("Chọn kho"),{
            condition:{
              status:true
            },
            props:{
                readOnly:true,
                formSize:"sm",
                hideTableHeader:true,
                hideHeader:true,
                cache_local:true,
                fullWidth:false,
                fullScreen:false,
                height:"auto",
                showPages:true
            },
            onClose:()=>{
              rs();
            },
            callback:(item)=>{
              rs(item);
            }
          })
        })
      }
    }
    stock_info = stock_info||{};
    if(voucher_code=="dh2_agent_midomax"){
      data.ma_kho = stock_info.ma_kho;
    }else{
      if(stock_info.la_kho_npp){
        //ban cho nha phan phoi
        voucher_code=(stock_info.user_npp===this.context.userInfo.email?"so9_npp_agent":"so9_agent");
        if(stock_info.user_npp!==this.context.userInfo.email )data.user_ctv = this.context.userInfo.email
        so_ct="SO9";
        data.ma_kho = stock_info.ma_kho;
      }else{
        if(stock_info.la_kho_thue){
          data.ma_kho = stock_info.ma_kho;
          so_ct="SO7";
          voucher_code="so7_agent"
        }
      }
    }
    //
    data.trang_thai="0";
    data.so_ct = so_ct;
    data.details =[];

    this.state.cart.filter(p=>p.sl_xuat).forEach(product=>{
      let detail = {
        ma_vt:product.ma_vt,
        ten_vt:product.ten_vt,
        ma_dvt:product.ma_dvt,
        sl_xuat:product.sl_xuat,

        he_so_qd:product.he_so_qd||1,
        sl_xuat_qd:(product.he_so_qd||1) * product.sl_xuat,

        ty_le_ck:product.ty_le_ck||0,
        tien_ck_nt:product.tien_ck_nt||0,
        thue_suat:product.thue_suat||0,
        ma_thue:product.ma_thue
      };
      detail.gia_ban_niem_yet_nt = detail.gia_ban_nt = detail.gia_ban = product.gia_ban_le || 0;
      detail.gia_ban_ct_nt = product.gia_ban_ct_nt||0;

      detail.ma_tt1 = product.ma_tt1;
      detail.nh_tt = product.nh_tt|| (product.thuoc_tinh||{}).nh_tt;
      detail.thuoc_tinh = product.thuoc_tinh;

      if(stock_info.la_kho_npp){
        detail.ma_kho = "";
        detail.tien_hang_nt=Math.roundBy(detail.sl_xuat*detail.gia_ban_nt,2);
        detail.tien_hang_ct_nt=Math.roundBy(detail.sl_xuat*detail.gia_ban_ct_nt,2);

        detail.tien_ck_nt = Math.roundBy(detail.ty_le_ck*detail.tien_hang_ct_nt/100,2);
        detail.tien_nt= detail.tien_hang_ct_nt- detail.tien_ck_nt;

        let thue_suat = product.thue_suat || 0;
        detail.tien_thue_nt = Math.roundBy((detail.tien_hang_ct_nt - (detail.tien_ck_nt||0)) * thue_suat/100,2);
        detail.tien_thue = detail.tien_thue_nt* (product.ty_gia||1);

      }else{
        detail.tien_nt=Math.roundBy(detail.sl_xuat*detail.gia_ban_nt,2);
        detail.tien_ct_nt=Math.roundBy(detail.sl_xuat*detail.gia_ban_ct_nt,2);
        detail.tien_ck_nt = Math.roundBy(detail.ty_le_ck*detail.tien_ct_nt/100,2);

        if(!stock_info.la_kho_thue)
          detail.ma_kho =  product.ma_kho_df;
        else
          detail.ma_kho = ""

        let thue_suat = product.thue_suat || 0;
        detail.tien_thue_nt = Math.roundBy((detail.tien_ct_nt - (detail.tien_ck_nt||0)) * thue_suat/100,2);
        detail.tien_thue = detail.tien_thue_nt* (product.ty_gia||1);
      }
      
      detail.ma_dvt= product.ma_dvt;
      detail.ma_vt2= product.ma_vt2;
      detail.ten_vt= product.ten_vt;
      detail.tk_vt = product.tk_vt;
      detail.tk_gv = product.tk_gv;
      detail.tk_dt = product.tk_dt;
      detail.ma_nvt = product.ma_nvt;
      data.details.push(detail);
    })
    window[`__tmp_${voucher_code}`] = data;
    window.location.href=`/#/quickinput/${voucher_code}`;
  }
  render(){
    return (
      <CartContext.Provider value={this.state}>
        {this.props.children}
      </CartContext.Provider>
    )
  }
}
Provider.contextType = DefaultContext;
export default Provider;